import { render } from "./VersionUpdateModal.vue?vue&type=template&id=66bf3b9d"
import script from "./VersionUpdateModal.vue?vue&type=script&lang=js"
export * from "./VersionUpdateModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__